import { UserInfoModel, WorkflowCurrentStepModel } from '@api/models/shared';
import { WorkflowStep } from '@core/api/models/technology/technology-request-detail.model';
import { ComplaintDurationTypeEnum } from '@features/technology/shared/enums/complaint-duration-type.enum';

export interface RequestForChange {
  id: string;
  title: string;
  batchNumber: string;
  type: string;
  decision: RequestForChangeDecision;
  description: string;
  deviceName: string;
  deviceNumber: string;
  positions: RequestForChangePosition[];
  documentsIdentifier: string;
  linkedDocumentsCount: number;
  notesCount: number;
  number: string;
  positionHierarchicalPath: number;
  originalProfessionNumber: string;
  originalStepTimeMinutes: number;
  originalWageClassNumber: string;
  originalPreparationTimeMinutes: number;
  operation: {
    operationId?: string;
    operationNumber: number;
    preparationTimeMinutes?: number;
    stepTimeMinutes?: number;
    professionId?: string;
    professionNumber?: string;
    wageClassId?: string;
    state: any;
  };
  partOfCarTypeNumber: string;
  preferredSolver: UserInfoModel;
  projectName: string;
  createdDate: string;
  createdByUser: UserInfoModel & { costCenterCode?: string };
  solvedByUser?: UserInfoModel;
  solvedDate?: string;
  acceptedByUser: UserInfoModel;
  acceptedDate?: string;
  deviceInstanceExternalId?: string;
  preparationTimeMinutes?: number;
  stepTimeMinutes?: number;
  newOperationCanBeCreated: boolean;
  workflowStep: WorkflowCurrentStepModel;
  isCreatedAutomatically: boolean;
  reports?: RequestForChangeReportItem[];
}

export interface RequestForChangeReportItem {
  publicId: string;
  number: string;
  createdByUser: UserInfoModel;
  createdDate: string;
  amountOfPieces: number;
  stepTimeMinutes?: number;
  preparationTimeMinutes?: number;
  totalTimeMinutes?: number;
  processingStartedDate?: string;
  processingFinishedDate?: string;
}

export interface RequestForChangePosition {
  positionHierarchicalPath: string;
  numberOfPiecesUnableToManufacture: number;
  operationNumber: number;
  stepTimeMinutes: number;
  preparationTimeMinutes: number;
  professionId: string;
  amountOfPieces?: number;
  workflowStepInfo: WorkflowStep;
}

export interface RequestForChangeSelectedPosition {
  positionHierarchicalPath: string;
  amountOfPieces?: number;
  operationNumber?: number;
  stepTimeMinutes?: number;
  preparationTimeMinutes?: number;
  numberOfPiecesUnableToManufacture?: number;
}

export interface CreateRequestForChange {
  batchNumber: string;
  title: string;
  description: string;
  type: string;
  preferredSolverId?: string;
  positions: RequestForChangePosition[];
  isCreatedAutomatically: boolean;
}

export interface RequestForChangeDecision {
  requestForChangeKindId?: string;
  summary: string;
  systemImpact?: string;
  durationType: ComplaintDurationTypeEnum;
  positionHierarchicalPath: string;
  stepTimeMinutes?: number;
  preparationTimeMinutes?: number;
  professionId?: string;
  wageClassId?: string;
}

export enum RequestForChangeType {
  MaterialLoss = 'MaterialLoss',
  ConstructionChange = 'ConstructionChange',
  TimeComplaint = 'TimeComplaint',
}

export class RequestForChangeSystem {
  public static readonly NormTimeIncrease = 'NormTimeIncrease';
  public static readonly NewOperation = 'NewOperation';
}
